/**
 * Backbone.js view for the login support component which implements "instant chat" using the Salesforce
 * Live Agent facility.
 *
 * User: mgodani
 * Date: 5/20/2014
 */
define(function (require) {
  'use strict';
  var $ = require('jquery'),
    _ = require('underscore'),
    Backbone = require('backbone'),

    Const = require('common/Const'),
    Alert = require('common/views/Alert'),
    LVS = require('components/live-agent/views/LiveVideoSupport'),
    template_html = require('components/live-agent/templates/LoginSupport.html'),
    template = _.template(template_html);

  return LVS.extend({

    activate: function () {
      this.toggleButton.trigger("click");
    },

    render: function () {
      var me = this,
        data = this._prepareData();
      this.$el.append(template(data));
      var bg = $("body").css("background-image");
      $(".blur-effect").css({
        backgroundImage: bg,
        backgroundPosition: "center",
        backgroundRepeat: "none"
      });
      this.widget = $("#login-support-widget");
      this.toggleButton = $(".login-support-widget-button", me.widget);
      var button = $("a.login-support-hidden", me.widget);
      var box = $(".login-support-box", me.widget);

      if (this.startActivated) {
        button.removeClass("login-support-hidden").addClass("login-support-visible");
        box.show();
      }

      var buttons = $(".login-support-widget-button, .login-support-box-header-close", me.widget);
      buttons.click(function () {
        if (box.is(":visible")) {
          button.addClass("login-support-hidden").removeClass("login-support-visible");
          box.hide();
        } else {
          button.removeClass("login-support-hidden").addClass("login-support-visible");
          box.show();
        }
      });

      this._loadLiveAgent('login-support-online', 'login-support-offline');
      this.trigger("LoginSupport::render");
      return this;
    },

    _prepareData: function () {
      var data = [];
      var me = this,
        nls = commonConfig.getNLSLanguage();

      data.i18n = i18n;
      data.type = this.type;

      return data;
    }
  });
});



//////////////////
// WEBPACK FOOTER
// ./js/components/live-agent/views/LoginSupport.js
// module id = 712
// module chunks = 26